<template>
  <div>
    <el-tabs v-model="activeName" type="card" class="tabs-one" style="border-top: 1px solid #c8c8c8;padding-top: 20px;">
      <el-tab-pane name="1" class="active">
        <span slot="label"><i class="el-icon"></i>我的顾问</span>
        <myfinancialAdvisor></myfinancialAdvisor>
      </el-tab-pane>
      <el-tab-pane name="2">
        <span slot="label"><i class="el-icon"></i>关注列表</span>
        <followLists></followLists>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import myfinancialAdvisor from "./myfinancialAdvisor.vue";
import followLists from "./followLists.vue";
export default {
  components: {
    myfinancialAdvisor,
    followLists,
  },
  data () {
    return {
      activeName: '1',
    }
  },
}
</script>

